import { SuperDate } from '@razlet/utils';
import Warehouse from '../warehouse';

export default class ShipmentWarehouse {
  assignRule = null;

  assignedAt = null;

  assignedBy = null;

  warehouse = null;

  constructor (data) {
    if (!data) return;
    this.assignRule = data.assignRule;
    this.assignedBy = data.assignedBy;
    this.assignedAt = new SuperDate(data.assignedAt);
    this.warehouse = new Warehouse(data.warehouse);
  }
};
